/**
 * Cart icon with item count bubble
 * Manages the shopping cart icon in the header with item count display
 * Handles cart drawer toggle functionality when clicked
 * Supports A/B testing via window.cartMode (can be 'drawer' or 'page')
 */

if (!customElements.get('cart-icon-bubble')) {
  class CartIconBubble extends HTMLElement {
    constructor() {
      super();

      this.toggleButton = this.querySelector('button');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.toggleButton.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      // A/B test support: check window.cartMode
      if (window.cartMode === 'page') {
        window.location.href = this.toggleButton.dataset.cartUrl || '/cart';
        return;
      }

      // Default drawer behavior
      if (this.cartDrawer) {
        this.cartDrawer.drawer.classList.contains(this.cartDrawer.activeClass)
          ? this.cartDrawer.close()
          : this.cartDrawer.open();
      }
    }
  }

  customElements.define('cart-icon-bubble', CartIconBubble);
}
